import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { setUser } from '../actions';
import api from '../utils/api';
import { startRefreshTokenTimer } from '../utils/refreshToken';
import { Spinner } from './CustomMui';

const ProtectedRoute = ({ component: Component, adminRoute, ...rest }) => {
  // get boolean for token to prevent rerender when token changes
  const haveToken = useSelector(state => {
    let haveToken = false;
    if (state.user.token) {
      haveToken = true;
    }
    return haveToken
  });

  const isAdmin = useSelector(state => state.user.isAdmin);

  const [redirect,setRedirect] = useState(false);

  const dispatch = useDispatch();


  /**
   * @todo
   * With checking for token and redirecting in api.js
   * this code may no longer be necessary (after refactor)
   */
  useEffect(() => {
    if (!haveToken) {
      api.refreshToken()
        .then(res => {
          startRefreshTokenTimer(res.data)
          dispatch(setUser(res.data));
        })
        .catch(err => {
          setRedirect(true)
        })
    }
  }, [dispatch,haveToken])

  
  if (!haveToken && !redirect) {
    return (
      <div style={{height: '100vh', display: 'flex'}}>
      <Spinner /> 
    </div>
    )
  } else {
    return <Route {...rest} render={ (props) => {    
      if (!haveToken) {
        return <Redirect to={`/login?redirect=${window.location.pathname}`} />
      }
  
      if (adminRoute && !isAdmin) {
        return <Redirect to='/not-allowed' />
      }
      
      return <Component {...props} />
  
    }} />
  }

  
}

export default ProtectedRoute;